import React, { Fragment } from "react";

const Select = ({
  field,
  handleFieldChanged,
  value,
  showSimplifiedOptions,
  handlePrefillOptions = { handlePrefillOptions },
  type,
}) => {
  console.log("select field", field);
  return (
    <select
      width="100%"
      onChange={(e) => handlePrefillOptions(type, e.target.value)}
    >
      <option>Choose prefill option</option>
      {field.options &&
        field.options.map((v, i) => {
          return <option value={v.value}>{v.label}</option>;
        })}
    </select>
  );
};

export default Select;
